<template>
    <main
        class="bg-noise fixed flex h-screen w-screen flex-col items-center justify-center overflow-hidden scroll-smooth bg-black bg-gradient-to-b from-accent-400/10 via-accent-400/15 via-20% to-accent-400/10 to-95% p-0 font-gilroy text-ash-200 max-lg:gap-10">
        <div
            class="container relative flex items-center justify-center md:h-[20rem]">
            <div class="fixed inset-0 z-10 h-screen w-screen">
                <BaseStar class="-top-10 left-1/3 z-10" />

                <BaseStar
                    reverse
                    :count="2"
                    class="left-4 top-1/2 z-10 sm:left-[20%]" />
                <BaseStar
                    :count="2"
                    class="left-1/4 top-1/4 z-10 md:left-0 md:top-0" />
                <BaseStar class="right-1/4 top-2/3 z-10" />

                <BaseStar
                    :count="2"
                    class="top-3/4 z-10 max-md:right-5 md:-left-24 md:top-[15%]" />
                <BaseStar class="right-[5%] top-[10%] z-10" />
            </div>

            <template v-if="props.error?.statusCode === 404">
                <picture>
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/ui/error/webp/404-desktop.webp
                        " />
                    <img
                        width="2880"
                        height="1232"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/404-desktop.png"
                        class="absolute left-0 top-[60%] z-20 hidden h-auto w-screen scale-150 md:block lg:top-1/4 lg:scale-125 xl:top-0 xl:scale-100" />
                </picture>

                <picture>
                    <source
                        type="image/webp"
                        srcset="/assets/images/ui/error/webp/404.webp" />
                    <img
                        width="825"
                        height="364"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/404.png"
                        class="z-20 md:hidden" />
                </picture>

                <picture>
                    <source
                        type="image/webp"
                        srcset="/assets/images/ui/error/webp/404-mobile.webp" />
                    <img
                        width="694"
                        height="622"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/404-mobile.png"
                        class="fixed bottom-0 left-1/2 z-20 max-w-[22rem] -translate-x-1/2 translate-y-20 md:hidden" />
                </picture>
            </template>

            <template v-if="props.error?.statusCode === 500">
                <picture>
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/ui/error/webp/500-desktop.webp
                        " />
                    <img
                        width="4320"
                        height="1254"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/500-desktop.png"
                        class="absolute left-0 top-[40%] z-20 hidden h-auto w-screen scale-[2] md:block lg:top-[10%] lg:scale-150 xl:top-[-5%] xl:scale-125" />
                </picture>

                <picture>
                    <source
                        type="image/webp"
                        srcset="/assets/images/ui/error/webp/500.webp" />
                    <img
                        width="977"
                        height="436"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/500.png"
                        class="z-20 md:hidden" />
                </picture>

                <picture>
                    <source
                        type="image/webp"
                        srcset="/assets/images/ui/error/webp/500-mobile.webp" />
                    <img
                        width="682"
                        height="534"
                        :alt="errorMessage"
                        src="/assets/images/ui/error/jpg-png/500-mobile.png"
                        class="fixed bottom-0 left-1/2 z-20 max-w-[22rem] -translate-x-1/2 translate-y-20 md:hidden" />
                </picture>
            </template>

            <div
                class="absolute left-1/2 top-0 z-10 aspect-square w-[50vw] min-w-[20rem] max-w-[50rem] -translate-y-1/2 animate-slow-pulse rounded-full bg-accent/80 blur-[6rem] transition-all delay-700 duration-300" />
        </div>
        <div
            class="container z-30 flex flex-col items-center justify-center space-y-7 pt-20">
            <h1 class="text-center text-24/133 font-semibold text-accent-100">
                {{ errorMessage }}
            </h1>
            <BaseLink
                to="/"
                icon-right="arrow-right"
                size="accent">
                На главную
            </BaseLink>
        </div>
    </main>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

import BaseLink from '~/components/base/base-link/BaseLink.vue'
import BaseStar from '~/components/base/base-star/BaseStar.vue'

const props = defineProps({
    error: {
        type: Object as () => NuxtError,
        required: true,
    },
})

const errorMessage = computed<string>(() => {
    switch (props.error?.statusCode) {
        case 404:
            return 'Страница не найдена'
        case 500:
            return 'Ошибка сервера'
        default:
            return 'Что-то пошло не так'
    }
})

const errorTitle = computed<string>(() => {
    switch (props.error?.statusCode) {
        case 404:
            return 'Такой страницы не существует'
        case 500:
            return 'Ошибка сервера'
        case 502:
        case 503:
        case 504:
            return 'Сервис временно недоступен'
        default:
            return 'Ошибка загрузки страницы'
    }
})

console.debug(props.error)
</script>
